exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview .thumbnail[data-v-92f49028]{height:110px;overflow:hidden;border-top-left-radius:unset;border-top-right-radius:unset}.asset-preview .thumbnail img[data-v-92f49028]{max-height:108px}.asset-preview .card-body .title[data-v-92f49028]{height:38px;line-height:18px;font-weight:500;cursor:pointer;overflow-wrap:anywhere}.number-of-proofs[data-v-92f49028]{display:inline-block;min-width:25px;height:25px;padding:3px;border-radius:50%;position:relative;top:-3px;line-height:1.6}", ""]);

// exports
